import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../utils/axios";

export const clearCache = createAsyncThunk("utility/clearCache", async () => {
  const res = await http.post("/dashboard/utility/clear-cache");
  return res.data;
});

export const clearHomepageCache = createAsyncThunk(
  "utility/clearHomepageCache",
  async () => {
    const res = await http.post("/dashboard/utility/clear-homepage-cache");
    return res.data;
  }
);

const utilitySlice = createSlice({
  name: "utility",
  initialState: {
    loading: false,
    error: null,
    message: null,
  },
  reducers: {
    clearMessage: (state) => {
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearCache.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Cache cleared successfully!";
      })
      .addCase(clearCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(clearHomepageCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearHomepageCache.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Homepage cache cleared successfully!";
      })
      .addCase(clearHomepageCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearMessage } = utilitySlice.actions;
export default utilitySlice.reducer;
